import { FC, useEffect, useState } from "react";
import useGeozonesPage from "./useGeozonesPage";
import {
  shared,
  customerPortal,
  DeleteConfirmationModal
} from "@vilocnv/allsetra-core";
import { MarkerObjectIcon } from "assets/icons";
const { LeftRightLayoutContainer, LeftSection, RightSection } = shared;
const { geozones } = customerPortal;
const {
  GeozonesList,
  GeozonesListHeader,
  GeozonesListItem,
  GeozonesListItemActions,
  GeozonesMap,
  GeozonesSearchInput
} = geozones;

const GeozonesPage: FC = () => {
  const [isMountingComponent, setIsMountingComponent] = useState(true);
  const [mounted, setMounted] = useState(false);
  const {
    geozones,
    isLoadingGeozones,
    markers,
    showMarkers,
    translator,
    theme,
    navigate,
    selectedTooltipMarker,
    selectedObject,
    onEditGeozoneClick,
    onDeleteGeozoneClick,
    onAddGeozoneButtonClick,
    handleMarkerMouseOver,
    handleMarkerMouseOut,
    handleShowInfoWindowClick,
    handleCloseInfoWindowClick,
    toggleShowMarkers,
    isLoadingObjectDetail,
    onGeozoneItemClick,
    isDeleting,
    onCloseDeleteModalClick,
    isDeleteModalOpen,
    onDeleteActionGeozoneClick
  } = useGeozonesPage();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;

    setIsMountingComponent(false);
  }, [mounted]);

  const isLoading = isMountingComponent || !!isLoadingGeozones;

  return (
    <>
      <LeftRightLayoutContainer>
        <LeftSection>
          <GeozonesSearchInput
            placeholder={translator("common.search")}
            isLoading={isLoading}
          />
          <GeozonesListHeader
            isLoading={isLoading}
            title={translator("drawerMenuLinks.geozones")}
            geozonesLength={geozones.length}
            onAddGeozoneButtonClick={onAddGeozoneButtonClick}
            theme={theme}
            buttonText={translator("titles.addGeozone")}
          />
          <GeozonesList geozones={geozones}>
            {(geozone, index) => (
              <GeozonesListItem
                isLoading={isLoading}
                geozone={geozone}
                countText={translator("drawerMenuLinks.objects")}
                onClick={onGeozoneItemClick}
                index={index}
                listLength={geozones.length}
              >
                <GeozonesListItemActions
                  onDeleteGeozoneClick={onDeleteActionGeozoneClick}
                  onEditGeozoneClick={onEditGeozoneClick}
                  geozone={geozone}
                  editGeozoneText={translator("titles.editGeozone")}
                  deleteGeozoneText={translator("titles.deleteGeozone")}
                />
              </GeozonesListItem>
            )}
          </GeozonesList>
        </LeftSection>
        <RightSection>
          <GeozonesMap
            handleCloseInfoWindowClick={handleCloseInfoWindowClick}
            isLoadingGeozones={isLoading}
            geozones={geozones}
            markers={markers}
            showMarkers={showMarkers}
            selectedObject={selectedObject}
            selectedTooltipMarker={selectedTooltipMarker}
            onShowMarkersClick={toggleShowMarkers}
            onMarkerMouseOver={handleMarkerMouseOver}
            onMarkerMouseOut={handleMarkerMouseOut}
            isLoadingObjectDetail={isLoadingObjectDetail}
            onShowInfoWindowClick={handleShowInfoWindowClick}
            translatorFn={translator}
            navigateFn={navigate}
            showMarkersIcon={<MarkerObjectIcon />}
            tooltipText={translator("common.showObjects")}
          />
        </RightSection>
      </LeftRightLayoutContainer>
      <DeleteConfirmationModal
        open={isDeleteModalOpen}
        onClose={() => onCloseDeleteModalClick()}
        title={translator("typography.deleteGeozoneTitle")}
        subTitle={translator("typography.deleteGeozoneSubtitle")}
        primaryBtnProps={{
          id: "geozone-delete",
          onClick: onDeleteGeozoneClick,
          loading: isDeleting,
          text: translator("buttonsText.delete")
        }}
        secondaryBtnProps={{
          text: translator("buttonsText.cancel")
        }}
      ></DeleteConfirmationModal>
    </>
  );
};

export default GeozonesPage;
